import React from 'react';
import { AppBar, Toolbar, Typography, IconButton, Box, Divider, alpha } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NotificationBell from './NotificationBell';

export default function Header({ handleDrawerToggle }) {
  const navigate = useNavigate();
  const location = useLocation();

  const showBackButton = location.pathname !== '/';

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar sx={{ gap: 0.5 }}>
        {/* Nút Menu luôn hiển thị trên mobile, kể cả ở trang con */}
        <IconButton
          color="inherit"
          aria-label="Mở menu"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ display: { md: 'none' } }}
        >
          <MenuIcon />
        </IconButton>

        {/* Nút Quay lại: chỉ ở trang con, tách khỏi Menu bằng vạch + nền viên thuốc mờ */}
        {showBackButton && (
          <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', ml: 0.5 }}>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ borderColor: (t) => alpha(t.palette.common.white, 0.35), my: 1.25, mr: 1 }}
            />
            <IconButton
              color="inherit"
              aria-label="Quay lại"
              size="small"
              onClick={() => navigate(-1)}
              sx={{
                bgcolor: (t) => alpha(t.palette.common.white, 0.16),
                borderRadius: 2,
                px: 1.25,
                py: 0.5,
                '&:hover': { bgcolor: (t) => alpha(t.palette.common.white, 0.28) },
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          </Box>
        )}

        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, ml: 1.5 }}>
          Pico-Time
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <NotificationBell />
        </Box>
      </Toolbar>
    </AppBar>
  );
}
